import { Swipe, SwipeItem } from 'vant';

export function setupVant(app) {
    app.use(Swipe);
    app.use(SwipeItem);
}
